import { getAddress, addAddress, editAddress, getAllAddressVerivied, getAllAddressVeriviedFilter, getAllAddress, addMoreAddress, removeAddress, setAsBillingAddress, editMyAddress, getBillingAddress, getAllAddressFilter, deleteAddress, fetchShipperSearchAddress, fetchConsigneeSearchAddress } from '@/api/address.api'

export const FETCH_ADDRESS_SHIPPER = 'FETCH_ADDRESS_SHIPPER'
export const FETCH_ADDRESS_SHIPPER_LOADING = 'FETCH_ADDRESS_SHIPPER_LOADING'
export const FETCH_ADDRESS_SHIPPER_DONE = 'FETCH_ADDRESS_SHIPPER_DONE'
export const FETCH_ADDRESS_SHIPPER_ERROR = 'FETCH_ADDRESS_SHIPPER_ERROR'

export const FETCH_ADDRESS_CONSIGNEE = 'FETCH_ADDRESS_CONSIGNEE'
export const FETCH_ADDRESS_CONSIGNEE_LOADING = 'FETCH_ADDRESS_CONSIGNEE_LOADING'
export const FETCH_ADDRESS_CONSIGNEE_DONE = 'FETCH_ADDRESS_CONSIGNEE_DONE'
export const FETCH_ADDRESS_CONSIGNEE_ERROR = 'FETCH_ADDRESS_CONSIGNEE_ERROR'

export const CREATE_ADDRESS = 'CREATE_ADDRESS'
export const CREATE_ADDRESS_LOADING = 'CREATE_ADDRESS_LOADING'
export const CREATE_ADDRESS_DONE = 'CREATE_ADDRESS_DONE'
export const CREATE_ADDRESS_ERROR = 'CREATE_ADDRESS_ERROR'

export const EDIT_ADDRESS = 'EDIT_ADDRESS'
export const EDIT_ADDRESS_LOADING = 'EDIT_ADDRESS_LOADING'
export const EDIT_ADDRESS_DONE = 'EDIT_ADDRESS_DONE'
export const EDIT_ADDRESS_ERROR = 'EDIT_ADDRESS_ERROR'

export const POST_DATA_ADDRESS_TEMP = 'POST_DATA_ADDRESS_TEMP'
export const POST_DATA_ADDRESS_TEMP_DONE = 'POST_DATA_ADDRESS_TEMP_DONE'

export const DELETE_ADDRESS = 'DELETE_ADDRESS'
export const DELETE_ADDRESS_LOADING = 'DELETE_ADDRESS_LOADING'
export const DELETE_ADDRESS_DONE = 'DELETE_ADDRESS_DONE'
export const DELETE_ADDRESS_ERROR = 'DELETE_ADDRESS_ERROR'

export const FETCH_ALL_ADDRESS_VERIVIED = 'FETCH_ALL_ADDRESS_VERIVIED'
export const FETCH_ALL_ADDRESS_VERIVIED_LOADING = 'FETCH_ALL_ADDRESS_VERIVIED_LOADING'
export const FETCH_ALL_ADDRESS_VERIVIED_DONE = 'FETCH_ALL_ADDRESS_VERIVIED_DONE'
export const FETCH_ALL_ADDRESS_VERIVIED_ERROR = 'FETCH_ALL_ADDRESS_VERIVIED_ERROR'

export const FETCH_ALL_ADDRESS_VERIVIED_FILTER = 'FETCH_ALL_ADDRESS_VERIVIED_FILTER'
export const FETCH_ALL_ADDRESS_VERIVIED_FILTER_LOADING = 'FETCH_ALL_ADDRESS_VERIVIED_FILTER_LOADING'
export const FETCH_ALL_ADDRESS_VERIVIED_FILTER_DONE = 'FETCH_ALL_ADDRESS_VERIVIED_FILTER_DONE'
export const FETCH_ALL_ADDRESS_VERIVIED_FILTER_ERROR = 'FETCH_ALL_ADDRESS_VERIVIED_FILTER_ERROR'

export const FETCH_ALL_ADDRESS = 'FETCH_ALL_ADDRESS'
export const FETCH_ALL_ADDRESS_LOADING = 'FETCH_ALL_ADDRESS_LOADING'
export const FETCH_ALL_ADDRESS_DONE = 'FETCH_ALL_ADDRESS_DONE'
export const FETCH_ALL_ADDRESS_ERROR = 'FETCH_ALL_ADDRESS_ERROR'

export const FETCH_ALL_ADDRESS_FILTER = 'FETCH_ALL_ADDRESS_FILTER'
export const FETCH_ALL_ADDRESS_FILTER_LOADING = 'FETCH_ALL_ADDRESS_FILTER_LOADING'
export const FETCH_ALL_ADDRESS_FILTER_DONE = 'FETCH_ALL_ADDRESS_FILTER_DONE'
export const FETCH_ALL_ADDRESS_FILTER_ERROR = 'FETCH_ALL_ADDRESS_FILTER_ERROR'

export const ADD_MORE_ADDRESS = 'ADD_MORE_ADDRESS'
export const ADD_MORE_ADDRESS_LOADING = 'ADD_MORE_ADDRESS_LOADING'
export const ADD_MORE_ADDRESS_DONE = 'ADD_MORE_ADDRESS_DONE'
export const ADD_MORE_ADDRESS_ERROR = 'ADD_MORE_ADDRESS_ERROR'

export const REMOVE_ADDRESS = 'REMOVE_ADDRESS'
export const REMOVE_ADDRESS_LOADING = 'REMOVE_ADDRESS_LOADING'
export const REMOVE_ADDRESS_DONE = 'REMOVE_ADDRESS_DONE'
export const REMOVE_ADDRESS_ERROR = 'REMOVE_ADDRESS_ERROR'

export const GET_BILLING_ADDRESS = 'GET_BILLING_ADDRESS'
export const GET_BILLING_ADDRESS_LOADING = 'GET_BILLING_ADDRESS_LOADING'
export const GET_BILLING_ADDRESS_DONE = 'GET_BILLING_ADDRESS_DONE'
export const GET_BILLING_ADDRESS_ERROR = 'GET_BILLING_ADDRESS_ERROR'

export const BILLING_ADDRESS_GLOBAL = 'BILLING_ADDRESS_GLOBAL'
export const BILLING_ADDRESS_GLOBAL_LOADING = 'BILLING_ADDRESS_GLOBAL_LOADING'
export const BILLING_ADDRESS_GLOBAL_DONE = 'BILLING_ADDRESS_GLOBAL_DONE'

export const SET_BILLING_ADDRESS = 'SET_BILLING_ADDRESS'
export const SET_BILLING_ADDRESS_LOADING = 'SET_BILLING_ADDRESS_LOADING'
export const SET_BILLING_ADDRESS_DONE = 'SET_BILLING_ADDRESS_DONE'
export const SET_BILLING_ADDRESS_ERROR = 'SET_BILLING_ADDRESS_ERROR'

export const EDIT_MY_ADDRESS = 'EDIT_MY_ADDRESS'
export const EDIT_MY_ADDRESS_LOADING = 'EDIT_MY_ADDRESS_LOADING'
export const EDIT_MY_ADDRESS_ERROR = 'EDIT_MY_ADDRESS_ERROR'
export const EDIT_MY_ADDRESS_DONE = 'EDIT_MY_ADDRESS_DONE'

export const SHIPPER_SEARCH_ADDRESS = 'SHIPPER_SEARCH_ADDRESS'
export const SHIPPER_SEARCH_ADDRESS_LOADING = 'SHIPPER_SEARCH_ADDRESS_LOADING'
export const SHIPPER_SEARCH_ADDRESS_ERROR = 'SHIPPER_SEARCH_ADDRESS_ERROR'
export const SHIPPER_SEARCH_ADDRESS_DONE = 'SHIPPER_SEARCH_ADDRESS_DONE'

export const CONSIGNEE_SEARCH_ADDRESS = 'CONSIGNEE_SEARCH_ADDRESS'
export const CONSIGNEE_SEARCH_ADDRESS_LOADING = 'CONSIGNEE_SEARCH_ADDRESS_LOADING'
export const CONSIGNEE_SEARCH_ADDRESS_ERROR = 'CONSIGNEE_SEARCH_ADDRESS_ERROR'
export const CONSIGNEE_SEARCH_ADDRESS_DONE = 'CONSIGNEE_SEARCH_ADDRESS_DONE'

export default {
  [FETCH_ADDRESS_SHIPPER] (context, type) {
    context.commit(FETCH_ADDRESS_SHIPPER_LOADING)
    return getAddress(type)
      .then((response) => {
        context.commit(FETCH_ADDRESS_SHIPPER_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_ADDRESS_SHIPPER_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_ADDRESS_CONSIGNEE] (context, type) {
    context.commit(FETCH_ADDRESS_CONSIGNEE_LOADING)
    return getAddress(type)
      .then((response) => {
        context.commit(FETCH_ADDRESS_CONSIGNEE_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_ADDRESS_CONSIGNEE_ERROR, true)
        console.error(error)
      })
  },

  [CREATE_ADDRESS] (context, payload) {
    context.commit(CREATE_ADDRESS_LOADING)
    return addAddress(payload)
      .then((response) => {
        context.commit(CREATE_ADDRESS_DONE, response)
      })
      .catch((error) => {
        context.commit(CREATE_ADDRESS_ERROR, true)
        console.error(error)
      })
  },

  [EDIT_ADDRESS] (context, payload) {
    context.commit(EDIT_ADDRESS_LOADING)
    return editAddress(payload)
      .then((response) => {
        context.commit(EDIT_ADDRESS_DONE, response)
      })
      .catch((error) => {
        context.commit(EDIT_ADDRESS_ERROR, error)
      })
  },

  [POST_DATA_ADDRESS_TEMP] (context, data) {
    return context.commit(POST_DATA_ADDRESS_TEMP_DONE, data)
  },

  [DELETE_ADDRESS] (context, id) {
    context.commit(DELETE_ADDRESS_LOADING)
    return deleteAddress(id)
      .then((response) => {
        context.commit(DELETE_ADDRESS_DONE, response)
      })
      .catch((error) => {
        context.commit(DELETE_ADDRESS_ERROR, error)
      })
  },

  [FETCH_ALL_ADDRESS_VERIVIED] (context, payload) {
    context.commit(FETCH_ALL_ADDRESS_VERIVIED_LOADING)
    return getAllAddressVerivied(payload.page, payload.perPage)
      .then((response) => {
        context.commit(FETCH_ALL_ADDRESS_VERIVIED_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_ALL_ADDRESS_VERIVIED_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_ALL_ADDRESS_VERIVIED_FILTER] (context, payload) {
    context.commit(FETCH_ALL_ADDRESS_VERIVIED_FILTER_LOADING)
    return getAllAddressVeriviedFilter(payload.page, payload.filter, payload.key, payload.perPage)
      .then((response) => {
        context.commit(FETCH_ALL_ADDRESS_VERIVIED_FILTER_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_ALL_ADDRESS_VERIVIED_FILTER_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_ALL_ADDRESS] (context, payload) {
    context.commit(FETCH_ALL_ADDRESS_LOADING)
    return getAllAddress(payload.page, payload.perPage)
      .then((response) => {
        context.commit(FETCH_ALL_ADDRESS_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_ALL_ADDRESS_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_ALL_ADDRESS_FILTER] (context, payload) {
    context.commit(FETCH_ALL_ADDRESS_FILTER_LOADING)
    return getAllAddressFilter(payload.page, payload.filter, payload.key, payload.perpage)
      .then((response) => {
        context.commit(FETCH_ALL_ADDRESS_FILTER_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_ALL_ADDRESS_FILTER_ERROR, true)
        console.error(error)
      })
  },

  [ADD_MORE_ADDRESS] (context, payload) {
    context.commit(ADD_MORE_ADDRESS_LOADING)
    return addMoreAddress(payload)
      .then((response) => {
        context.commit(ADD_MORE_ADDRESS_DONE, response)
      })
      .catch((error) => {
        context.commit(ADD_MORE_ADDRESS_ERROR, true)
        console.error(error)
      })
  },

  [REMOVE_ADDRESS] (context, payload) {
    context.commit(REMOVE_ADDRESS_LOADING)
    return removeAddress(payload)
      .then((response) => {
        context.commit(REMOVE_ADDRESS_DONE, response)
      })
      .catch((error) => {
        context.commit(REMOVE_ADDRESS_ERROR, true)
        console.error(error)
      })
  },

  [SET_BILLING_ADDRESS] (context, payload) {
    context.commit(SET_BILLING_ADDRESS_LOADING)
    return setAsBillingAddress(payload)
      .then((response) => {
        context.commit(SET_BILLING_ADDRESS_DONE, response)
      })
      .catch((error) => {
        context.commit(SET_BILLING_ADDRESS_ERROR, true)
        console.error(error)
      })
  },

  [EDIT_MY_ADDRESS] (context, payload) {
    context.commit(EDIT_MY_ADDRESS_LOADING)
    return editMyAddress(payload)
      .then((response) => {
        context.commit(EDIT_MY_ADDRESS_DONE, response)
      })
      .catch((error) => {
        context.commit(EDIT_MY_ADDRESS_ERROR, true)
        console.error(error)
      })
  },

  [GET_BILLING_ADDRESS] (context, page) {
    context.commit(GET_BILLING_ADDRESS_LOADING)
    return getBillingAddress()
      .then((response) => {
        context.commit(GET_BILLING_ADDRESS_DONE, response)
      })
      // eslint-disable-next-line handle-callback-err
      .catch((error) => {
        context.commit(GET_BILLING_ADDRESS_ERROR, true)
      })
  },

  [BILLING_ADDRESS_GLOBAL] (context, data) {
    return context.commit(BILLING_ADDRESS_GLOBAL_DONE, data)
  },

  [SHIPPER_SEARCH_ADDRESS] (context, payload) {
    context.commit(SHIPPER_SEARCH_ADDRESS_LOADING)
    return fetchShipperSearchAddress(payload)
      .then((response) => {
        context.commit(SHIPPER_SEARCH_ADDRESS_DONE, response)
      })
      .catch((error) => {
        context.commit(SHIPPER_SEARCH_ADDRESS_ERROR, true)
        console.error(error)
      })
  },

  [CONSIGNEE_SEARCH_ADDRESS] (context, payload) {
    context.commit(CONSIGNEE_SEARCH_ADDRESS_LOADING)
    return fetchConsigneeSearchAddress(payload)
      .then((response) => {
        context.commit(CONSIGNEE_SEARCH_ADDRESS_DONE, response)
      })
      .catch((error) => {
        context.commit(CONSIGNEE_SEARCH_ADDRESS_ERROR, true)
        console.error(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/address/actions.js